import { useState } from 'react'
import { Mtds, PlusIcon } from 'prove-common'
import CreatePlanModal from '../create-plan-modal/CreatePlanModal'
import type { WorkspaceId } from '../../workspaces/workspaces'

type CreatePlanButtonProps = {
  workspaceId?: WorkspaceId
}

export function CreatePlanButton({ workspaceId }: CreatePlanButtonProps) {
  const [isOpen, setIsOpen] = useState(false)

  if (!isOpen) {
    return (
      <Mtds.Flex>
        <Mtds.Button data-variant='primary' onClick={() => setIsOpen(true)}>
          <PlusIcon />
          Ny plan
        </Mtds.Button>
      </Mtds.Flex>
    )
  }

  return (
    <CreatePlanModal
      isOpen={isOpen}
      setOpen={setIsOpen}
      parentPlan={undefined}
      workspaceId={workspaceId}
    />
  )
}
